var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5733 3.84467C11.2804 3.55178 10.8055 3.55178 10.5126 3.84467C10.2197 4.13756 10.2197 4.61244 10.5126 4.90533L15.0643 9.45703H3.95703C3.54282 9.45703 3.20703 9.79282 3.20703 10.207C3.20703 10.6212 3.54282 10.957 3.95703 10.957H15.0652L10.5125 15.5128C10.2197 15.8058 10.2198 16.2807 10.5128 16.5735C10.8058 16.8663 11.2807 16.8661 11.5735 16.5731L17.4046 10.7381L17.4055 10.7372C17.4082 10.7345 17.4109 10.7318 17.4136 10.729C17.6299 10.5059 17.6802 10.1817 17.5645 9.9115C17.5318 9.83498 17.4857 9.76281 17.4263 9.69851C17.4837 9.76069 17.5307 9.8326 17.5645 9.9115M11.5733 3.84467L17.4029 9.67432L11.5733 3.84467Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.aec26f091db30e686c9926b41691a284.svg";
export { ForwardRef as ReactComponent };